import FinalRegistryPhasePage from '../../../components/registry/FinalRegistryPhasePage';
import type { PhasePageProps } from '../../../components/registry/RegistryPhaseWorkspace';

/** Faza 4 — Registru & Follow-up: diagnosticul de registru, vizitele de control. */
export default function Faza4Page({ record, patient, status }: PhasePageProps) {
  return <FinalRegistryPhasePage title="Faza 4 — Registru & Follow-up" record={record} patient={patient} status={status} />;
}
